import $ from 'jquery';

class TopicSpotlight {
    constructor() {
        this.initialize();
    }

    initialize() {
        this.$tabs = $('.topic-spotlight__tab');
        this.$tabsContent = $('.topic-spotlight__tab-content');
        this.$tabs.on('click', e => this.updateTabs(e));
    }

    updateTabs(e) {
        this.$tabs.removeClass('active');
        this.$tabsContent.removeClass('active');
        this.$clickedTab = $(e.currentTarget);

        let $activeTab = this.$clickedTab.data('tab-index');
        this.$clickedTab.addClass('active');
        this.$tabsContent.each(function() {
            if ($(this).data('tab-index') == $activeTab) {
                $(this).addClass('active');
            }
        });
    }

    static init() {
        if ($('.topic-spotlight').length > 0) {
            new TopicSpotlight();
        }
    }
}

export default TopicSpotlight;
